import { Link } from "react-router-dom";
import { FaArrowRight, FaExternalLinkAlt } from "react-icons/fa";
import { useTheme } from "../Theme/ThemeContext";

export default function HorizontalSection({ title, posts, icon, gradient }) {
  const { currentTheme } = useTheme();
  const gradientClass = gradient || currentTheme.colors.gradient;
  
  return (
    <div className="mb-8">
      {/* Section title */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          {icon && (
            <div className={`p-2.5 bg-gradient-to-br ${gradientClass} rounded-xl text-white shadow-lg`}>
              {icon}
            </div>
          )}
          <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 dark:text-white">{title}</h2>
        </div>
        <Link 
          to="/jobs" 
          className="group flex items-center gap-2 text-sm font-semibold text-theme-primary hover:opacity-80 transition-colors"
        >
          View all
          <FaArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
      
      {/* Cards grid */}
      <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {posts.map((post, idx) => (
          <PostCard key={post?.id || post?._id || `${idx}`} {...post} gradientClass={gradientClass} />
        ))}
      </div>
    </div>
  );
}

const PostCard = ({ title, companyLogo, companyName, id, _id, gradientClass }) => {
  const { currentTheme } = useTheme();
  const gradient = gradientClass || currentTheme.colors.gradient;
  const jobId = id || _id;
  const companyInitial = String(companyName || "C").trim().slice(0, 1).toUpperCase();

  return (
    <div className="group glass rounded-2xl border border-white/20 dark:border-white/10 shadow-sm hover:shadow-lg hover:border-accent-200/50 dark:hover:border-accent-800/50 transition-all duration-300 p-5 flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-start gap-3">
        {companyLogo ? (
          <div className="w-12 h-12 rounded-xl overflow-hidden border border-white/30 dark:border-white/10 bg-white dark:bg-neutral-700 flex-shrink-0 shadow-sm">
            <img
              src={companyLogo}
              alt={companyName ? `${companyName} logo` : "Company logo"}
              className="w-full h-full object-contain p-1"
            />
          </div>
        ) : (
          <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center flex-shrink-0 shadow-sm`}>
            <span className="text-white font-bold">{companyInitial}</span>
          </div>
        )}
        
        <div className="min-w-0 flex-1">
          <p className="text-xs text-neutral-500 dark:text-neutral-400 mb-1 line-clamp-1">{companyName}</p>
          <h3 className="text-base font-bold text-neutral-900 dark:text-white line-clamp-2 group-hover:text-theme-primary transition-colors">
            {title}
          </h3>
        </div>
      </div>

      {/* Action */}
      <div className="mt-auto pt-2">
        <Link
          to={`/jobs/${jobId}`}
          className={`inline-flex items-center justify-center gap-2 w-full py-2.5 px-4 rounded-xl text-sm font-semibold text-white bg-gradient-to-r ${gradient} hover:opacity-90 transition-all shadow-sm hover:shadow-md group-hover:scale-[1.02]`}
        >
          View details
          <FaExternalLinkAlt className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
};
